import cn from 'classnames';

import Button from 'components/common/Button';
import Text from 'components/common/Text';
import Minus from 'components/icons/actions/Minus';
import Plus from 'components/icons/actions/Plus';
import { TEMPO } from 'context/BrandContext';
import useBrand from 'hooks/useBrand';

const NumberSelector = ({ value, onChange, min = 0, max = 10, className, name, step = 1 }) => {
  const isTempo = useBrand(TEMPO);

  const handleDecrement = () => {
    const newValue = value - step;
    if (newValue >= min) {
      onChange(newValue);
    }
  };

  const handleIncrement = () => {
    const newValue = value + step;
    if (newValue <= max) {
      onChange(newValue);
    }
  };

  const getAriaLabel = (action, targetValue) => {
    return `${action} ${name.toLowerCase()} to ${targetValue}`;
  };

  return (
    <div className={cn('flex', className)}>
      <div className="flex h-12 items-center gap-1 rounded bg-charcoal-50 px-1">
        <Button
          type="button"
          onClick={handleDecrement}
          disabled={value <= min}
          variation="Ghost"
          className={cn(
            'h-12 w-12 border-none p-0 hover:bg-charcoal-60 active:bg-charcoal-70 bp1:h-8 bp1:w-8',
            {
              'opacity-50': value <= min,
            }
          )}
          ariaLabel={getAriaLabel('Decrease', value - step)}
        >
          <Minus
            className={cn('h-5 w-5', {
              'text-green-100': !isTempo,
              'text-tempo-black-100': isTempo,
            })}
          />
        </Button>

        <div className="flex h-10 min-w-10 items-center justify-center">
          <Text htmlElement="span" className="select-none text-center font-medium">
            {value}
          </Text>
        </div>

        <Button
          type="button"
          onClick={handleIncrement}
          disabled={value >= max}
          variation="Ghost"
          className={cn(
            'h-12 w-12 border-none p-0 hover:bg-charcoal-60 active:bg-charcoal-70 bp1:h-8 bp1:w-8',
            {
              'opacity-50': value >= max,
            }
          )}
          ariaLabel={getAriaLabel('Increase', value + step)}
        >
          <Plus
            className={cn('h-5 w-5', {
              'text-green-100': !isTempo,
              'text-tempo-black-100': isTempo,
            })}
          />
        </Button>
      </div>
    </div>
  );
};

NumberSelector.propTypes = {
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  min: PropTypes.number,
  max: PropTypes.number,
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
  step: PropTypes.number,
};

export default NumberSelector;
